import React from "react";
import {FormattedMessage} from "react-intl";
import TableRow from "./TableRow";
import Loader from "../Utils/Loader";
import Empty from "./Empty";
import classes from "./styles.module.css";

function PcaTable({contractsList, contracts, terminals, loading}) {
    return loading ? (
        <Loader/>
    ) : (
        <table className={classes.Table}>
            <thead>
            <tr>
                <th><FormattedMessage id="PcaTable.table.id" defaultMessage="Идентификатор"/></th>
                <th><FormattedMessage id="PcaTable.table.name" defaultMessage="Название ПСА"/></th>
                <th><FormattedMessage id="PcaTable.table.contract" defaultMessage="Контракт"/></th>
                <th><FormattedMessage id="PcaTable.table.provider" defaultMessage="Провайдер"/></th>
                <th><FormattedMessage id="PcaTable.table.date" defaultMessage="Дата ПСА"/></th>
                <th><FormattedMessage id="PcaTable.table.amount" defaultMessage="Сумма"/></th>
                <th><FormattedMessage id="PcaTable.table.status" defaultMessage="Статус"/></th>
                <th/>
            </tr>
            </thead>
            <tbody>
            {!loading && contractsList && contractsList.length > 0 ? (
                contractsList.map((el, i) => (
                    <TableRow key={i} data={el} contracts={contracts} terminals={terminals}/>
                ))
            ) : (
                <Empty/>
            )}
            </tbody>
        </table>
    );
}

export default PcaTable;



// WEBPACK FOOTER //
// ./src/Components/PcaTable/index.js